import { Link } from 'react-router-dom';
import { LanguageSwitcher } from '@/components/LanguageSwitcher';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen flex">
      {/* Left side - Form */}
      <div className="flex-1 flex flex-col py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
        {/* Language switcher at top */}
        <div className="flex justify-end mb-4">
          <LanguageSwitcher />
        </div>

        <div className="flex-1 flex flex-col justify-center">
          <div className="mx-auto w-full max-w-sm lg:w-96">
            <div className="mb-8">
              <Link to="/" className="flex items-center gap-2">
                <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
                  <span className="text-white font-bold text-xl">M</span>
                </div>
                <span className="text-2xl font-bold">Mawkaa</span>
              </Link>
            </div>
            {children}
          </div>
        </div>
      </div>

      {/* Right side - Image/Branding */}
      <div className="hidden lg:block relative w-0 flex-1">
        <div className="absolute inset-0 bg-gradient-to-br from-primary to-primary/80">
          <div className="absolute inset-0 flex flex-col items-center justify-center text-white p-12">
            <h1 className="text-4xl font-bold mb-4">Votre place sur le web</h1>
            <p className="text-xl text-white/80 text-center max-w-md">
              Créez votre site web professionnel en moins de 15 minutes, sans compétences techniques.
            </p>
            <div className="mt-12 grid grid-cols-3 gap-8 text-center">
              <div>
                <div className="text-3xl font-bold">10+</div>
                <div className="text-sm text-white/70">Templates</div>
              </div>
              <div>
                <div className="text-3xl font-bold">15 min</div>
                <div className="text-sm text-white/70">Pour créer</div>
              </div>
              <div>
                <div className="text-3xl font-bold">0</div>
                <div className="text-sm text-white/70">Code requis</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
